// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"6641d0c0d0800742bbd2","293":"297e876d19386ac5d34c","461":"4f7b04c1df757859392d","518":"344a1bea2d67e746ea5c","779":"de8e3788515ad129d748"}[chunkId] + ".js";
};